export default __webpack_public_path__ + "static/media/maternity-care-icon.4160fa9a.svg";